import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Breadcrumb, Icon } from '../../../';
import { ContextConsumer } from './Context';
import NavDropdown from './NavDropdown';
import NavItem from './NavItem';
import NavMenuHeading from './NavMenuHeading';
import NavMenuItem from './NavMenuItem';

var HeaderNav = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeaderNav, _React$PureComponent);

  var _super = _createSuper(HeaderNav);

  function HeaderNav() {
    var _this;

    _classCallCheck(this, HeaderNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "dropdownRefs", {});

    _defineProperty(_assertThisInitialized(_this), "onCloseForKey", function (key) {
      return function () {
        var ref = _this.dropdownRefs[key];
        ref && ref.current && ref.current.onClose();
      };
    });

    return _this;
  }

  _createClass(HeaderNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          _this$props$links = _this$props.links,
          links = _this$props$links === void 0 ? [] : _this$props$links,
          DefaultLinkWrapper = _this$props.LinkWrapper,
          inverted = _this$props.inverted,
          productName = _this$props.productName;
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-nav header"
      }, productName && /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Section, null, productName)), links.map(function (_ref) {
        var key = _ref.key,
            href = _ref.href,
            label = _ref.label,
            noDefaultHeading = _ref.noDefaultHeading,
            _ref$links = _ref.links,
            subLinks = _ref$links === void 0 ? [] : _ref$links,
            _ref$LinkWrapper = _ref.LinkWrapper,
            LinkWrapper = _ref$LinkWrapper === void 0 ? DefaultLinkWrapper : _ref$LinkWrapper,
            linkProps = _objectWithoutProperties(_ref, ["key", "href", "label", "noDefaultHeading", "links", "LinkWrapper"]);

        var hasSub = subLinks.length > 0;
        var isSubItemActive = hasSub ? !!subLinks.find(function (l) {
          return l.key === activeKey;
        }) : false;

        if (hasSub && !_this2.dropdownRefs[key]) {
          _this2.dropdownRefs[key] = /*#__PURE__*/React.createRef(null);
        }

        var onClose = hasSub && _this2.onCloseForKey(key);

        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: key
        }, hasSub ? /*#__PURE__*/React.createElement(NavDropdown, {
          className: "cloud-ui-header-item",
          inverted: inverted,
          isActive: isSubItemActive || activeKey === key,
          label: /*#__PURE__*/React.createElement("div", {
            className: "label"
          }, label, /*#__PURE__*/React.createElement(Icon, {
            className: "sub-arrow down",
            name: "chevron-down"
          })),
          pinned: true,
          position: "bottom left",
          ref: _this2.dropdownRefs[key]
        }, !noDefaultHeading && /*#__PURE__*/React.createElement(NavMenuHeading, null, label), subLinks.map(function (_ref2) {
          var subKey = _ref2.key,
              subLabel = _ref2.label,
              heading = _ref2.heading,
              _ref2$LinkWrapper = _ref2.LinkWrapper,
              SubLinkWrapper = _ref2$LinkWrapper === void 0 ? LinkWrapper : _ref2$LinkWrapper,
              subLinkProps = _objectWithoutProperties(_ref2, ["key", "label", "heading", "LinkWrapper"]);

          return heading ? /*#__PURE__*/React.createElement(NavMenuHeading, {
            key: subKey
          }, subLabel) : /*#__PURE__*/React.createElement(NavMenuItem, _extends({
            key: subKey
          }, subLinkProps, {
            isActive: activeKey === subKey,
            LinkWrapper: SubLinkWrapper,
            onClick: function onClick() {
              var onClick = subLinkProps.onClick;

              if (typeof onClick === 'function') {
                onClick();
              }

              onClose();
            }
          }), subLabel);
        })) : /*#__PURE__*/React.createElement(NavItem, _extends({}, linkProps, {
          href: href,
          isActive: activeKey === key,
          LinkWrapper: LinkWrapper
        }), /*#__PURE__*/React.createElement("div", {
          className: "label"
        }, label)));
      }));
    }
  }]);

  return HeaderNav;
}(React.PureComponent);

export default (function (props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref3) {
    var activeKey = _ref3.activeKey,
        links = _ref3.links,
        LinkWrapper = _ref3.LinkWrapper;
    return /*#__PURE__*/React.createElement(HeaderNav, _extends({}, props, {
      activeKey: activeKey,
      links: links,
      LinkWrapper: LinkWrapper
    }));
  });
});